import React from "react";
import { Box } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { WARN } from "./tokens";
import { issueCount, issueSummary } from "./stepIssues";

/**
 * The collapsing card each builder step lives in: numbered header, a summary
 * while collapsed, and the body only while active.
 *
 * A real component rather than a helper that returns JSX. Both keep controlled
 * inputs focused (only a component defined INSIDE another component remounts
 * every render), and this way each step's markup can live in its own file.
 */
export const StepSection = ({
  n, title, subTitle, summary, badge, children,
  activeStep, maxStep, attempted, issues, isEdit, onOpen, classes,
}) => {
  const active = activeStep === n;
  const done = maxStep > n && !active;
  const locked = n > maxStep;
  // A collapsed step that was attempted and is now invalid still advertises it,
  // or editing an earlier step and navigating away would hide the error.
  const shown = attempted[n] ? issues : [];
  const showErr = shown.length > 0 && !active;
  const errorText = issueSummary(shown);
  const numCls = showErr ? classes.secNumError : active ? classes.secNumActive : done ? classes.secNumDone : "";

  return (
    <Box className={`${classes.section} ${locked ? classes.sectionLocked : ""} ${showErr ? classes.sectionErr : ""}`}>
      <Box className={`${classes.secHead} ${active ? classes.secHeadOpen : ""}`}
        style={{ cursor: locked || active ? "default" : "pointer" }}
        onClick={() => !active && onOpen(n)}>
        <span className={`${classes.secNum} ${numCls}`}>
          {showErr ? "!" : done ? <CheckIcon style={{ fontSize: 16 }} /> : locked ? <LockOutlinedIcon style={{ fontSize: 14 }} /> : n}
        </span>
        <span className={classes.secTitle} style={showErr ? { color: WARN } : undefined}>{title}</span>
        {/* Status qualifies the SECTION, so it sits beside the title rather than
            trailing it and shunting the summary a different distance per card. */}
        {badge}
        <span className={classes.secSub} style={showErr ? { color: WARN, fontWeight: 600 } : undefined}>
          {active ? subTitle : showErr ? (errorText || "Needs attention") : summary}
        </span>
        <span className={classes.secTail}>
          {/* Explicit, because reopening a step is not a free jump: it re-locks
              every step after it and you have to Continue back. */}
          {done && !isEdit && (
            <button type="button" className={classes.editBtn}
              onClick={(e) => { e.stopPropagation(); onOpen(n); }}>Edit</button>
          )}
        </span>
      </Box>
      {active && <Box className={classes.secBody}>{children}</Box>}
    </Box>
  );
};

// The full issue list for a step, shown inside the open card.
export const IssueBanner = ({ issues, classes }) => {
  if (!issues.length) return null;
  return (
    <Box className={classes.issueBox}>
      <ErrorOutlineIcon className={classes.issueIco} />
      <Box style={{ minWidth: 0 }}>
        {issues.length === 1 ? (
          <div className={classes.issueOne}>{issues[0]}</div>
        ) : (
          <>
            <div className={classes.issueHead}>{issueCount(issues.length)}</div>
            <ul className={classes.issueList}>
              {issues.map((m, i) => <li key={i}>{m}</li>)}
            </ul>
          </>
        )}
      </Box>
    </Box>
  );
};
